import styled from '@emotion/styled'
import { AnimatedTitle } from 'app/components/Common/Animation/AnimatedTitle'
import { FadeInUp } from 'app/components/Common/Animation/FadeInUp'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { styles } from 'app/theme'
import React, { memo } from 'react'

import { Item } from './Item'

export interface Props {
  list?: any[]
  title?: string
}

export const Info = memo(function Info({ list, title }: Props) {
  if (!list) {
    return null
  }

  return (
    <Container row space="between" tag="section" wrap>
      {title ? <Title tag="h2" text={title} /> : null}

      <List row wrap>
        {list.map((item, index) => (
          <FadeInUp delay={index * 0.1} key={index}>
            <Item {...item} />
          </FadeInUp>
        ))}
      </List>
    </Container>
  )
})

const Container = styled(FlexBox)`
  border-top: 0.0625rem solid
    ${({ theme }) => theme.colors.variants.primaryDark};
  margin-top: 11.25rem;
  gap: 7.778vw;
  padding: 3.625rem 5vw 0;

  @media (max-width: 1199px) {
    display: block;
    margin: 5.25rem 2rem 0;
    padding: 0.8125rem 0 0;
  }
`

const Title = styled(AnimatedTitle)`
  ${styles.title.large}
`

const List = styled(FlexBox)`
  flex: 1;
  gap: 4rem;

  > div {
    flex: 1;
  }

  @media (max-width: 1199px) {
    display: block;
    max-width: none;

    > div {
      margin-top: 3.75rem;
      &:first-of-type {
        margin-top: 2rem;
      }
    }
  }
`
